module.exports = __webpack_public_path__ + "assets/img/ftr_twitter.webp?fae48fdcc88f8c4f7b5c20e8cca65a1f";